import MatchType from "./MatchType";

export default class BasketballStatus {
    static ERROR = 0
    static NOT_START = 1
    static PART_1 = 2
    static PART_1_END = 3
    static PART_2 = 4
    static PART_2_END = 5
    static PART_3 = 6
    static PART_3_END = 7
    static PART_4 = 8
    static ADD_TIME = 9
    static FINISH = 10
    static INTERRUPT = 11
    static CANCELED = 12
    static PUT_OFF = 13
    static WAIST_CUT = 14
    static DETERMINED = 15
    static ROUNDS = ["第1节", "第2节", "第3节", "第4节", "加时"];

    static getStatus(status) {
        switch (status) {
            case BasketballStatus.ERROR:
                return '比赛异常';
            case BasketballStatus.NOT_START:
                return '未开赛';
            case BasketballStatus.PART_1:
                return '第一节';
            case BasketballStatus.PART_1_END:
                return '第一节完';
            case BasketballStatus.PART_2:
                return '第二节';
            case BasketballStatus.PART_2_END:
                return '第二节完';
            case BasketballStatus.PART_3:
                return '第三节';
            case BasketballStatus.PART_3_END:
                return '第三节完';
            case BasketballStatus.PART_4:
                return '第四节';
            case BasketballStatus.ADD_TIME:
                return '加时';
            case BasketballStatus.FINISH:
                return '完场';
            case BasketballStatus.PUT_OFF:
                return '推迟';
            case BasketballStatus.INTERRUPT:
                return '中断';
            case BasketballStatus.WAIST_CUT:
                return '腰斩';
            case BasketballStatus.CANCELED:
                return '取消';
            case BasketballStatus.DETERMINED:
                return '待定';
        }
        return '';
    }

    static getType(type) {
        const STRARR = ['', '3分球进球数', '2分球进球数', '罚球进球数', '剩余暂停数', '犯规数', '罚球命中率', '总暂停数'];
        return STRARR[type] ? STRARR[type] : '';
    }
}